var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTable = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_table_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 18C63 15.5147 60.9853 13.5 58.5 13.5H13.5C11.0147 13.5 9 15.5147 9 18V58.5C9 60.9853 11.0147 63 13.5 63H58.5C60.9853 63 63 60.9853 63 58.5V18ZM13.5 18H58.5V58.5H13.5V18Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9,
    y: 31.5,
    width: 54,
    height: 4.5,
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 2",
    x: 9,
    y: 18,
    width: 54,
    height: 4.5,
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 3",
    x: 31.5,
    y: 22.5,
    width: 4.5,
    height: 40.5,
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 4",
    x: 45,
    y: 22.5,
    width: 4.5,
    height: 40.5,
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy",
    x: 9,
    y: 45,
    width: 54,
    height: 4.5,
    fill: "#858585"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/table.7afeca6397c0b2c1757437e399f9717f.svg";